
export class ApiError extends Error {
  public responseData: any;
  public status?: number;

  constructor(message: string, responseData: any, status?: number) {
    super(message);
    this.responseData = responseData;
    this.status = status;
  }
}